import EyekandyEventLogging from "../abstracts/EyekandyEventLogging";

class EyekandySyndicationLogging extends EyekandyEventLogging {
  constructor(options) {
    super(options)
    //
    //  Set the values from our current class.
    this.destination = "syndication"
    this.syndicatedByAllInOne = false
  }

  preLogCallback(payload) {
    //
    //  Ok, now return the payload exactly as it will be sent.
    return payload
  }

  getLocalStorageKeyForABTest(service) {
    let value = null
    value = this.storageWrapper("local", `eky-ab-${service}`, "get") || null
    return value
  }

  log(type, detail, service, arid) {
    //
    //  Always sent ARID as a string.
    if (arid) {
      arid = `${arid}`
    }
    //
    //  Define our logging payload.
    const payload = {
      type: type || null,
      detail: detail || null,
      service: service || null,
      arid: arid || null
    }

    //
    //  :ab-testing:
    //  When A/B testing is enabled we need to read the A/B group from localstorage.
    //  TODO: The logic below means that the A/B group for any service on the page
    //        if it was syndicated by all-in-one - the A/B group for all-in-one is used.
    let abGroup = null
    if (this.syndicatedByAllInOne) {
      //
      //  When marked as syndicated by all-in-one, we need to upsert the A/B group.
      abGroup = this.getLocalStorageKeyForABTest("all-in-one")
    } else {
      //
      //  We can just read using the current service name.
      abGroup = this.getLocalStorageKeyForABTest(service)
    }
    // 
    //  If we read a value for the abGroup, add it to our payload.
    if (abGroup) {
      payload.ab = abGroup
    }

    //
    //  Send the log out.
    return this._log(payload)
  }

  updateDistributor(distributor) {
    this.distributor = distributor
  }

  updateLanguage(language) {
    this.language = language
  }

  updateEnvironment(environment) {
    this.environment = environment
  }

  setSyndicatedByAllInOne() {
    this.syndicatedByAllInOne = true
  }

}

//
//  :exports:
export default EyekandySyndicationLogging
